//Central config for @-mention entities. Used by the mention picker, the inline
//token renderer (mentionHelper), and the global SearchModal so the type keys,
//module colors, icons, and navigation routes stay consistent.
//
//`type`      — short token type stored inline in text (⟦type:id:label⟧)
//`searchKey` — key returned by the universal_search RPC
//`color`     — theme color token (module color)
//`icon`      — ionicon name (outline used in lists/tabs)
//`route`     — builds the navigation path for a single entity
//
//Array order defines tab priority (first type with a match is shown first).

const MENTION_ENTITIES = [
    { type: 'person',   searchKey: 'people',   label: 'People',   color: 'people',   icon: 'person-outline',        route: (id) => `/people/${id}` },
    { type: 'event',    searchKey: 'events',   label: 'Events',   color: 'events',   icon: 'calendar-outline',      route: (id) => `/events/${id}` },
    { type: 'task',     searchKey: 'tasks',    label: 'Tasks',    color: 'tasks',    icon: 'checkbox-outline',      route: (id) => `/tasks/${id}` },
    { type: 'training', searchKey: 'training', label: 'Training', color: 'training', icon: 'school-outline',        route: (id) => `/training/${id}` },
    { type: 'group',    searchKey: 'groups',   label: 'Groups',   color: 'groups',   icon: 'people-circle-outline', route: (id) => `/smallgroups/${id}` },
    { type: 'path',     searchKey: 'paths',    label: 'Automations', color: 'paths', icon: 'git-branch-outline',   route: (id) => `/automations/${id}` },
    { type: 'form',     searchKey: 'forms',    label: 'Forms',    color: 'forms',    icon: 'document-text-outline', route: (id) => ({ pathname: `/forms/${id}`, params: { mode: 'fill' } }) },
    { type: 'file',     searchKey: 'files',    label: 'Files',    color: 'textSecondary', icon: 'document-outline',    route: () => '/files' },
];

//Lookups
const MENTION_ENTITY_BY_TYPE = MENTION_ENTITIES.reduce((acc, e) => { acc[e.type] = e; return acc; }, {});
const MENTION_ENTITY_BY_SEARCH_KEY = MENTION_ENTITIES.reduce((acc, e) => { acc[e.searchKey] = e; return acc; }, {});

//The universal_search `types` array for the mention picker (all mentionable entities)
const MENTION_SEARCH_TYPES = MENTION_ENTITIES.map(e => e.searchKey);

const getMentionEntity = (type) => MENTION_ENTITY_BY_TYPE[type] || null;

export {
    MENTION_ENTITIES,
    MENTION_ENTITY_BY_TYPE,
    MENTION_ENTITY_BY_SEARCH_KEY,
    MENTION_SEARCH_TYPES,
    getMentionEntity,
};
